import { Button, Modal } from '@iwoca/orion';
import { usePatchIntroducerStatus } from 'lendingApi/lendingApiHooks';
import { showSuccessToast } from '../../UserManagementToast';
import { TIntroducerListItem } from '../UsersTable.types';
import styles from './DeactivateUserModal.module.css';

type TProps = {
  user: TIntroducerListItem;
  isOpen: boolean;
  onClose: () => void;
};

export const DeactivateUserModal = ({ user, isOpen, onClose }: TProps) => {
  const { mutate, isPending, isError, reset } = usePatchIntroducerStatus();

  const onConfirm = () => {
    reset();
    mutate(
      {
        introducerId: user.id,
        body: { data: { is_active: false } },
      },
      {
        onSuccess: () => {
          showSuccessToast('User has been deactivated');
          onClose();
        },
      },
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Deactivate ${user.first_name} ${user.last_name}?`}
      size="large"
    >
      <div className={styles.content}>
        <p className={styles.body}>
          They’ll lose access to the portal immediately. You can reactivate them
          at any time.
        </p>
        {isError && (
          <p className={styles.error}>
            Couldn’t deactivate user. Please try again.
          </p>
        )}
        <div className={styles.footer}>
          <Button
            variant="tertiary"
            type="button"
            onClick={onClose}
            disabled={isPending}
          >
            Cancel
          </Button>
          <Button variant="action" loading={isPending} onClick={onConfirm}>
            Deactivate
          </Button>
        </div>
      </div>
    </Modal>
  );
};
